module.exports = __webpack_public_path__ + "img/path-check-decagram.759b739a.svg";